module.exports = __webpack_public_path__ + "img/header-1.12225e4.jpeg";